import type { NavTabsProps } from './NavTabs'
import NavTabs from './NavTabs'

export type { NavTabsProps }
export default NavTabs
